import { FadeUp, GoldDot } from "@/components/Reveal";

const QUOTES = [
  {
    text: "I had such an incredible massage with Elena! From the moment I walked in, the atmosphere was one of a kind and very relaxing. She took the time to understand what I needed and was so kind, professional, and skilled. Truly one of the best massage experiences I’ve ever had. I highly recommend her.",
    author: "May S.",
    role: null,
  },
  {
    text: "After trying several massage therapists, I finally found Elena. She is highly skilled, attentive, and truly understands how different muscle groups work together. Her use of cupping, scraping, and myofascial techniques makes each treatment feel thorough and effective. She is also kind, easy to talk to, and just as comfortable to be in silence with.",
    author: "Sue V.",
    role: null,
  },
  {
    text: "As a fellow massage therapist, I truly appreciate Elena’s knowledge, skill, and approach to bodywork. Her treatments are confident, intuitive, and incredibly relaxing. She has a natural ability to find areas that need attention while making the entire experience feel calm and unhurried. I always leave feeling lighter, more relaxed, and restored.",
    author: "Valentin",
    role: null,
  },
];

const Testimonials = () => (
  <section
    data-chapter="06"
    data-testid="testimonials-section"
    className="bg-ivory pt-14 pb-28 lg:pt-20 lg:pb-40"
  >
    <div className="mx-auto max-w-[1500px] px-6 lg:px-14">
      <FadeUp className="mb-14 flex items-center justify-center gap-5">
        <span className="h-px w-24 bg-gold/80" />
        <span className="font-sans text-[11px] font-medium uppercase tracking-[0.4em] text-gold">06 — Kind Words</span>
        <span className="h-px w-24 bg-gold/80" />
      </FadeUp>

      <div className="grid gap-16 lg:grid-cols-3 lg:gap-12">
        {QUOTES.map((q, i) => (
          <FadeUp
            key={q.author}
            delay={0.1 + i * 0.15}
            className={`flex flex-col ${i === 1 ? "lg:mt-16" : ""}`}
            data-testid={`testimonial-${i}`}
          >
            <GoldDot className="mb-8 opacity-70" />
            <p className="font-serif text-xl font-light italic leading-snug text-forest/90 lg:text-[1.45rem]">
              “{q.text}”
            </p>
            <p className="mt-8 font-sans text-[11px] font-medium uppercase tracking-[0.32em] text-walnut/75">
              {q.author}{q.role && <> — <span className="text-walnut/45">{q.role}</span></>}
            </p>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
